import { call, put, takeEvery } from "@redux-saga/core/effects";
import {
  SIGNIN_START,
  SIGNIN_SUCCESS,
  SIGNIN_ERROR,
  LOGOUT_START,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  START_FORGOT_PASSWORD,
  SUCCESS_FORGOT_PASSWORD,
  ERROR_FORGOT_PASSWORD,
  START_RESET_PASSWORD,
  SUCCESS_RESET_PASSWORD,
  ERROR_RESET_PASSWORD,
  START_VERIFY_RESET_PASSWORD_LINK,
  SUCCESS_VERIFY_RESET_PASSWORD_LINK,
  ERROR_VERIFY_RESET_PASSWORD_LINK,
  START_PHARMACY_CREATE_PASSWORD,
  SUCCESS_PHARMACY_CREATE_PASSWORD,
  ERROR_PHARMACY_CREATE_PASSWORD,
} from "Actions/AuthAction";
import API from "Api";
import {
  loginUserAPI,
  forgotPasswordAPI,
  logoutUserAPI,
  resetPasswordAPI,
  checkResetPassoword,
  createPharmacyPasswordAPI,
} from "Api/AuthApis";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  setLocalStorage,
  clearAuthInfoFromLocalStorage,
  logoutUser,
} from "utils/generalUtils";

function* SigninWorker({ signinData }) {
  try {
    const response = yield call(loginUserAPI, signinData);
    if (response.success) {
      API.setAccessTokenInLocalStorage(response.data.token);
      setLocalStorage("role", response.data.role);
      yield put({
        type: SIGNIN_SUCCESS,
        data: response,
        token: response.token,
      });
    } else {
      yield put({
        type: SIGNIN_ERROR,
        data: response,
      });
    }
  } catch (error) {}
}

function* forgotPasswordWorker({ email }) {
  try {
    const response = yield call(forgotPasswordAPI, email);
    if (response.success) {
      yield put({
        type: SUCCESS_FORGOT_PASSWORD,
        payload: response,
      });
    } else {
      yield put({
        type: ERROR_FORGOT_PASSWORD,
        payload: response,
      });
    }
  } catch (error) {}
}
function* resetPasswordWorker({ data, token }) {
  try {
    const response = yield call(resetPasswordAPI, data, token);
    if (response.success) {
      API.setAccessTokenInLocalStorage(response.data.token);
      setLocalStorage("role", response.data.role);
      yield put({
        type: SUCCESS_RESET_PASSWORD,
        payload: response,
        token: response.token,
      });
    } else {
      yield put({
        type: ERROR_RESET_PASSWORD,
        payload: response,
      });
    }
  } catch (error) {}
}

function* verifyResetPasswordLinkWorker({ token }) {
  try {
    const response = yield call(checkResetPassoword, token);
    if (response.success) {
      yield put({
        type: SUCCESS_VERIFY_RESET_PASSWORD_LINK,
        payload: response,
      });
    } else {
      yield put({
        type: ERROR_VERIFY_RESET_PASSWORD_LINK,
        payload: response,
      });
    }
  } catch (error) {}
}

function* LogoutWorker() {
  try {
    const response = yield call(logoutUserAPI);
    if (response?.success) {
      clearAuthInfoFromLocalStorage();
      yield put({
        type: LOGOUT_SUCCESS,
        payload: response,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Logout successfully.",
          type: "success",
        },
      });
      logoutUser();
    } else {
      yield put({
        type: LOGOUT_ERROR,
        payload: response,
      });

    }
  } catch (error) {}
}

function* createPharmacyPasswordWorker({ data, token }) {
  try {
    const response = yield call(createPharmacyPasswordAPI, data, token);
    if (response.success) {
      API.setAccessTokenInLocalStorage(response.data.token);
      yield put({
        type: SUCCESS_PHARMACY_CREATE_PASSWORD,
        payload: response,
        token: response.token,
      });
    } else {
      yield put({
        type: ERROR_PHARMACY_CREATE_PASSWORD,
        payload: response,
      });
    }
  } catch (error) {}
}

export function* AuthWatcher() {
  yield takeEvery(SIGNIN_START, SigninWorker);
  yield takeEvery(START_FORGOT_PASSWORD, forgotPasswordWorker);
  yield takeEvery(START_RESET_PASSWORD, resetPasswordWorker);
  yield takeEvery(
    START_VERIFY_RESET_PASSWORD_LINK,
    verifyResetPasswordLinkWorker
  );
  yield takeEvery(LOGOUT_START, LogoutWorker);
  yield takeEvery(START_PHARMACY_CREATE_PASSWORD, createPharmacyPasswordWorker);
}
